import SignUpPanel from './sign-up-panel';

export default SignUpPanel;
